export default "__VITE_PUBLIC_ASSET__eaed2f32__"